import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import JuniorsPage from './pages/JuniorsPage';
import ClubPage from './pages/ClubPage';
import ComitePage from './pages/ComitePage';
import LocationClubhousePage from './pages/LocationClubhousePage';
import TennisPage from './pages/TennisPage';
import PadelPage from './pages/PadelPage';
import PadelMatchsOuvertsPage from './pages/PadelMatchsOuvertsPage';
import CompetitionsPage from './pages/CompetitionsPage';
import InterclubsPage from './pages/InterclubsPage';
import InterclubsJuniorsPage from './pages/InterclubsJuniorsPage';
import TeamChallengePage from './pages/TeamChallengePage';
import TournoisPage from './pages/TournoisPage';
import TarifsPage from './pages/TarifsPage';
import EvenementsPage from './pages/EvenementsPage';
import SponsorsPage from './pages/SponsorsPage';
import TimelinePage from './pages/TimelinePage';
import StageTennisPage from './pages/StageTennisPage';
import ContactModal from './components/ContactModal';
import { ContactModalProvider, useContactModal } from './contexts/ContactModalContext';

function AppContent() {
  const { isContactModalOpen, closeContactModal } = useContactModal();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/juniors" element={<JuniorsPage />} />
          <Route path="/club" element={<ClubPage />} />
          <Route path="/comite" element={<ComitePage />} />
          <Route path="/location-clubhouse" element={<LocationClubhousePage />} />
          <Route path="/tennis" element={<TennisPage />} />
          <Route path="/padel" element={<PadelPage />} />
          <Route path="/padel-matchs-ouverts" element={<PadelMatchsOuvertsPage />} />
          <Route path="/competitions" element={<CompetitionsPage />} />
          <Route path="/interclubs" element={<InterclubsPage />} />
          <Route path="/interclubs-juniors" element={<InterclubsJuniorsPage />} />
          <Route path="/team-challenge" element={<TeamChallengePage />} />
          <Route path="/tournois" element={<TournoisPage />} />
          <Route path="/tarifs" element={<TarifsPage />} />
          <Route path="/evenements" element={<EvenementsPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/timeline" element={<TimelinePage />} />
          <Route path="/stage-tennis" element={<StageTennisPage />} />
        </Routes>
      </BrowserRouter>
      
      {/* Modal global au niveau App */}
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </div>
  );
}

function App() {
  return (
    <ContactModalProvider>
      <AppContent />
    </ContactModalProvider>
  );
}

export default App;